import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response.model';
import { ApiService } from 'src/app/core/services/api.service';
import { IUserCart } from 'src/app/core/models/user-cart.model';
import { ClientDetails } from '../models/profile';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  tabs = [
    {
      id: 0, name: 'profile.myProfile', link: 'my-profile'
      , objHeader: {
        title: 'profile.myProfile',
        description: 'profile.myProfileDescription'
      }
    },
    { id: 1, name: 'appointment.myAppointments', link: 'my-appointments'
      ,objHeader:{
        title: 'appointment.myAppointments',
        description: 'appointment.myAppointmentsDescription'
      }
     },
    //  { id: 1, name: 'wallet.myWallet', link: 'my-wallet'
    //   ,objHeader:{
    //     title: 'wallet.myWallet',
    //     description: 'appointment.myAppointmentsDescription'
    //   }
    //  },
    //  { id: 1, name: 'Loyalty_point.myLoyaltyPoint', link: 'my-loyaltyPoint'
    //   ,objHeader:{
    //     title: 'Loyalty_point.myLoyaltyPoint',
    //     description: 'appointment.myAppointmentsDescription'
    //   }
    //  },
    //  { id: 1, name: 'gift.myGiftCards', link: 'my-giftCards'
    //   ,objHeader:{
    //     title: 'gift.myGiftCards',
    //     description: 'appointment.myAppointmentsDescription'
    //   }
    //  }
  ];

  selectedTab$: BehaviorSubject<any> = new BehaviorSubject<any>(this.tabs[0]);

  constructor(private readonly apiService: ApiService) {}


  getCLientDetails(): Observable<ApiResponse<ClientDetails>> {
    return this.apiService.get<ApiResponse<ClientDetails>>('/client/info');
  }

  getHeader(){
    return this.selectedTab$.getValue().objHeader
  }
  setHeader(index: number) {
    this.selectedTab$.next(this.tabs[index]);
  }
  // getProfileHistory(): Observable<ApiResponse<any>> {
  //   return this.apiService.get<ApiResponse<any>>('/orders', { });
  // }
}
